export const radioTheme = {
  circle: {
    display: "flex",
    "align-items": "center",
    "font-size": "12px",
    cursor: "pointer",
    "margin-bottom": "0px !important",
    "margin-top": "10px",
    ".input": {
      width: "0px",
      height: "0px",
      "z-index": 10,
      opacity: 0,
    },
    ".checkbox-input": {
      "margin-right": "0.25rem",
    },
    ".svg-block": {
      width: "18px",
      height: "18px",
      border: "2px solid #c298bb",
      "border-radius": "50%",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    ".icon": {
      width: "14px",
      color: "#c298bb",
    },
  },
  box: {
    display: "flex",
    "align-items": "center",
    "font-size": "12px",
    cursor: "pointer",
    "margin-bottom": "0px !important",
    "margin-top": "10px",
    width: "min-content",
    ".input": {
      width: "0px",
      height: "0px",
      "z-index": 10,
      opacity: 0,
    },
    ".checkbox-input": {
      "margin-right": "0.25rem",
    },
    ".svg-block": {
      width: "18px",
      height: "18px",
      background: "#A5A5A5",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    ".svg-checked": {
      background: "#c298bb",
    },
    ".icon": {
      width: "150%",
      height: "150%",
      color: "#c298bb",
    },
    ".svg-block-lg": {
      width: "28px",
      height: "28px",
      border: "4px solid #DEDEDE",
      background: "transparent",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      ".icon": {
        width: "150%",
        height: "150%",
        color: "#444561",
      },
    },
    ".svg-block-lg-checked": {
      width: "28px",
      height: "28px",
      border: "4px solid #707070",
      background: "transparent",
      overflow: "hidden",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
  },
};
